<template>
    <div class="video-feed">
      <DreamBroker v-if="video.type == 'dreamBrokerFeed'" :video="video.url" />
    </div>
      
  </template>
  
  <script>

import DreamBroker from "./VideoFeeds/DreamBroker.vue";

  export default {
    name: "VideoFeed",
    components: {
      DreamBroker,
    },
    props: {
      video: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        defaultClientName: "",
      };
    },
    methods: {
    
    }
  };
  </script>
  